module.exports = __webpack_public_path__ + "img/ASP.e7c13332.png";